import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { User } from '@models/user.model';
import { computed } from '@angular/core';
import { Section } from '@models/section.model';
import { MembershipYear } from '@models/membershipYear.model';

type AppState = {
  user: User | undefined;
  section: Section | undefined;
  isLoading: boolean;
};

const initialState: AppState = {
  user: undefined,
  section: undefined,
  isLoading: false
};

export const AppStore = signalStore(
  { providedIn: 'root', protectedState: false },
  withState(initialState),
  withComputed(({ user }) => ({
    authReady: computed(() => !!user())
  })),
  withMethods(store => {
    return {
      loadUser(user: User): void {
        patchState(store, state => ({ user: user }));
      },
      loadSection(section: Section): void {
        patchState(store, state => ({ section: section }));
      },
      logout(): void {
        patchState(store, state => ({ user: undefined, section: undefined }));
      }
    };
  })
);
